import React from 'react';
import { Button, Text } from '@clockout-dev/design-elements';
import { PlusCircleOutlined } from '@ant-design/icons';
import BalanceRuleRow from '../BalanceRuleRow';
import EmptyState from '../../../../../common/emptyState/EmptyState';
import { EMPLOYMENT_TYPE_OPTIONS } from '../../availableBalanceForm.constants';
import styles from '../../styles/availableBalanceForm.module.scss';

function LimitsPanel({
    employmentRules = [],
    balanceRules = [],
    balanceOptions = [],
    onAddEmployment,
    onAddBalance,
    onRemoveEmployment,
    onRemoveBalance,
    onUpdateEmployment,
    onUpdateBalance,
}) {
    const hasBalanceOptions = balanceOptions.length > 0;
    const showEmploymentEmpty = employmentRules.length === 0;
    const showBalanceEmpty = hasBalanceOptions && balanceRules.length === 0;

    return (
        <div className={styles.panel}>
            <div className={styles.panelBlock}>
                <Text as="span" size="s" className={styles.panelBlockTitle}>
                    Employment Type
                </Text>
                {employmentRules.map((rule) => (
                    <BalanceRuleRow
                        key={`employment-${rule.id}`}
                        rule={rule}
                        conditionType="employment"
                        options={EMPLOYMENT_TYPE_OPTIONS}
                        onUpdate={onUpdateEmployment}
                        onRemove={onRemoveEmployment}
                    />
                ))}
                {showEmploymentEmpty && (
                    <EmptyState
                        title="No employment rules yet"
                        description="Add a row to cap the available balance by employment type."
                    />
                )}
                <Button
                    type="button"
                    size="s"
                    variant="text"
                    className={styles.addRowButton}
                    onClick={onAddEmployment}
                >
                    <PlusCircleOutlined />
                    Add a user segment
                </Button>
            </div>

            <div className={styles.panelBlock}>
                <Text as="span" size="s" className={styles.panelBlockTitle}>
                    Avg. Daily Balance
                </Text>
                {balanceRules.map((rule) => (
                    <BalanceRuleRow
                        key={`balance-${rule.id}`}
                        rule={rule}
                        conditionType="balance"
                        options={balanceOptions}
                        onUpdate={onUpdateBalance}
                        onRemove={onRemoveBalance}
                        disabled={!hasBalanceOptions}
                    />
                ))}
                {!hasBalanceOptions && (
                    <p className={styles.disabledHelper}>
                        No additional settings are required based on your segmentation.
                    </p>
                )}
                {showBalanceEmpty && (
                    <EmptyState
                        title="No balance rules yet"
                        description="Add a row to cap the available balance by avg. daily balance."
                    />
                )}
                <Button
                    type="button"
                    size="s"
                    variant="text"
                    className={styles.addRowButton}
                    onClick={onAddBalance}
                    disabled={!hasBalanceOptions}
                >
                    <PlusCircleOutlined />
                    Add a user segment
                </Button>
            </div>
        </div>
    );
}

export default LimitsPanel;
